import { Component, Input } from '@angular/core';

export interface InvoiceContactData {
  supplierName: string;
  invoiceNumber: string;
  amountDue: number;
}

@Component({
  selector: 'app-invoice-contact-card',
  templateUrl: './invoice-contact-card.component.html',
  styleUrls: ['./invoice-contact-card.component.scss']
})
export class InvoiceContactCardComponent {
  @Input() invoiceData: InvoiceContactData | null = null;

  constructor() { }
}
